import React, { Component } from 'react'
import { Switch, Route, NavLink, Link } from "react-router-dom";

import '../../assets/fonts/fonts.css';
import './Layout.css';

//components
import Sidebar from '../Sidebar/Sidebar'
import Logout from '../Logout';
// Pages
import Dashboard from '../../pages/Dashboard/Dashboard'
import Profile from '../../pages/Users/profile/Profile'
import ChangePassword from '../../pages/Users/password/ChangePassword'

//user route
import UsersList from '../../pages/Users/users/UsersList'
import SingleUser from '../../pages/Users/users/SingleUser'

import NotFound from '../../pages/NotFound/NotFound'
import avatars from '../../assets/img/avatars.jpg'

//Image routes
import UploadImages from '../../pages/Dashboard/UploadImages';
import CreateImage from '../../pages/Dashboard/CreateImage';
import ImageGallery from '../../pages/Dashboard/ImageGallery';
import CreatedImageList from '../../pages/Dashboard/CreatedImages/CreatedImageList';

//Icons
import PersonIcon from '@material-ui/icons/Person';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import ListIcon from '@material-ui/icons/List';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import MenuIcon from '@material-ui/icons/Menu';
import CreateCategory from '../../pages/Dashboard/Categories/CreateCategory';
import CategoriesList from '../../pages/Dashboard/Categories/CategoriesList';
import CategoryEdit from '../../pages/Dashboard/Categories/CategoryEdit';
import BannerUpdate from '../../pages/Dashboard/Banner/BannerUpdate';

import EditorSample from '../../pages/Dashboard/EditorSample';
import CreateFaq from '../../pages/Dashboard/Faq/CreateFaq';
import FaqsList from '../../pages/Dashboard/Faq/FaqsList';
import EditFaq from '../../pages/Dashboard/Faq/EditFaq';
import SampleGreeting from '../../pages/Dashboard/SampleGreeting/SampleGreeting';

class Layout extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isSidebarOpen: true,
        }
    }
    SidebarToggle = () => {
        this.setState({
            isSidebarOpen: !this.state.isSidebarOpen
        });
    }

    render() {
        const { isSidebarOpen} = this.state;
        return (
            <div className="main-wrapper">
                <Sidebar SidebarOpen={isSidebarOpen} />
                <div className={`c-wrapper c-fixed-component ${isSidebarOpen ? '' : 'ml0'}`}>
                    <header className="c-header c-header-light c-header-fixed c-header-with-subheader">
                        <button class="c-header-toggler c-class-toggler mfs-3 d-md-down-none" type="button" onClick={this.SidebarToggle}>
                            <MenuIcon />
                        </button>
                       
                        <ul className="c-header-nav ml-auto mr-4">
                        
                            <li className="c-header-nav-item d-md-down-none mx-2 ft-18">
                                <Link to="/" className="c-header-nav-link"><NotificationsNoneIcon /> </Link>
                            </li>
                            <li className="c-header-nav-item d-md-down-none mx-2 ft-18">
                                <Link to="/" className="c-header-nav-link"><ListIcon /> </Link>
                            </li>
                            <li className="c-header-nav-item d-md-down-none mx-2 ft-18">
                                <Link to="/" className="c-header-nav-link"><MailOutlineIcon /></Link>
                            </li>
                            <li className="c-header-nav-item dropdown profile-menu">
                                <div className="c-avatar"><img className="c-avatar-img" src={avatars} alt="user@email.com" /></div>
                                <ul className="profile-link-dropdown">
                                    <li><NavLink to="/app/profile" className="profile-link" activeClassName="headerLinkActive"><PersonIcon /> Profile</NavLink></li>
                                    <li><NavLink to="/app/change-password" className="profile-link" activeClassName="headerLinkActive"><LockOpenIcon /> Change Password</NavLink></li>
                                    <li><Logout /></li>
                                </ul>
                            </li>
                        </ul>
                    </header>
                    <main>
                        <Switch>
                            <Route path="/app/main" exact component={Dashboard} />
                            <Route path="/app/profile" exact component={()=><Profile/>} />
                            <Route path="/app/change-password" exact component={ChangePassword} />
                            <Route path="/app/users" exact component={UsersList} />
                            <Route path="/app/users/:id" exact component={SingleUser} />
                            <Route path="/app/images/create/:id" exact component={CreateImage} />
                            <Route path="/app/images/gallery" exact component={ImageGallery} />
                            <Route path="/app/images/upload" exact component={UploadImages} />
                            <Route path="/app/categories/create" exact component={CreateCategory} />
                            <Route path="/app/categories" exact component={CategoriesList} />
                            <Route path="/app/categories/edit/:id" exact component={CategoryEdit} />
                            <Route path="/app/created-image-list" exact component={CreatedImageList} />
                            <Route path="/app/EditorSample" exact component={EditorSample} />
                            <Route path="/app/banner-update" exact component={BannerUpdate} />
                            <Route path="/app/create-faq" exact component={CreateFaq} />
                            <Route path="/app/faqs" exact component={FaqsList} />
                            <Route path="/app/faqs/edit/:id" exact component={EditFaq} />
                            <Route path="/app/sample-greetings" exact component={SampleGreeting} />
                            <Route component={NotFound} />
                        </Switch>
                    </main>
                </div>

            </div>
        )
    }
}

export default Layout;